import { isEmpty } from 'lodash';
import requester from 'utils/requester';
import api from 'config/api';
import { GRID_MAX_SIZE as ITEMS_PER_REQUEST } from 'config';
import { hideLoader, showLoader } from 'actions/loader';
import { selectPurchasesList } from 'reducers/purchases/selectors';
import * as types from './types';
import Platform from 'platform';

const paramsByType = {
  vod: {
    url: `${api.host}${api.endpoints.searchVod}`,
    params: {
      f_userData: 'purchases',
      f_deviceType: Platform.getDeviceType(),
      type: 'ALL',
      searchMetadata: true,
      detailed: true,
      includeVod: true,
      size: ITEMS_PER_REQUEST,
    },
  },
};

export const fetchPurchases = (type) => async (dispatch) => {
  try {
    const queryParams = paramsByType[type];

    if (!queryParams) return;

    dispatch(showLoader());
    dispatch({ type: types.FETCH, payload: { type } });

    const { content } = await requester({
      method: 'get',
      ...queryParams,
    });

    dispatch({ type: types.FETCH_SUCCESS, payload: { content, type } });
    if (content.length < ITEMS_PER_REQUEST) {
      dispatch({ type: types.LOAD_EXTRA_ITEMS_COMPLETED, payload: { type } });
    }
  } catch (error) {
    console.error(error);
    dispatch({
      type: types.FETCH_ERROR,
      payload: { error, type },
    });
  } finally {
    dispatch(hideLoader());
  }
};

export const loadExtraPurchasedItems = (type) => async (dispatch, getState) => {
  try {
    const purchased = selectPurchasesList(getState())[type];
    const { isOnLazyLoad, isAllItemsWereLoaded } = purchased;
    const page = purchased.page + 1;

    if (isOnLazyLoad || isAllItemsWereLoaded) return;

    const queryParams = paramsByType[type];

    dispatch({ type: types.LOAD_EXTRA_ITEMS, payload: { type } });

    const { content } = await requester({
      method: 'get',
      url: queryParams.url,
      params: { ...queryParams.params, page },
    });

    if (isEmpty(content)) {
      dispatch({ type: types.LOAD_EXTRA_ITEMS_COMPLETED, payload: { type } });
    } else {
      dispatch({
        type: types.LOAD_EXTRA_ITEMS_SUCCESS,
        payload: { type, content, page },
      });
    }
  } catch (error) {
    console.error(error);
    dispatch({ type: types.LOAD_EXTRA_ITEMS_ERROR, payload: { type, error } });
  }
};

export const resetAllPurchasesData = () => ({ type: types.RESET_ALL_DATA });
